import PropTypes from "prop-types"
import React from "react"
import withRouter from "components/Common/withRouter"
import { useSelector } from "react-redux"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"
import SuperAdminSidebar from "components/SuperAdmin/SuperAdminSidebar"

import { Link } from "react-router-dom"
import { WuloojWhiteFull } from "assets/images"

// import logo from "../../assets/images/logo.svg"
// import logo from "assets/images/superadmin/wulooj-mark.png"

const Sidebar = props => {
  const accountType = useSelector(state => state.Login?.accountType)
  const accountScope = useSelector(state => state.Login?.accountScope)
  const tenantLogoUrl = useSelector(
    state => state.Login?.authUser?.tenantBranding?.logoUrl || ""
  )
  const isSuperAdminSession =
    accountScope === "super_admin" || accountType === "superadmin"
  const activeLogo = !isSuperAdminSession && tenantLogoUrl ? tenantLogoUrl : WuloojWhiteFull

  if (isSuperAdminSession) {
    return <SuperAdminSidebar />
  }

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={activeLogo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={activeLogo} alt="" height="17" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={activeLogo} alt="" height="23" />
            </span>
            <span className="logo-lg">
              <img src={activeLogo} alt="" height="39" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

export default withRouter(withTranslation()(Sidebar))
